import React from 'react';
import { Paper, Typography } from '@mui/material';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PeopleIcon from '@mui/icons-material/People';
import ListIcon from '@mui/icons-material/ListAlt';
import { useTranslation } from 'react-i18next';
import StatCard from '../../../CalculateMoney/StatCard';
import StatCardsRow from '../../../CalculateMoney/StatCardsRow';
import EarningsBarChartDaily from '../../../CalculateMoney/Charts/EarningsBarChartToday';
import { statPaper, statTitle } from '../../../../styles/CalculateMoney/OverviewCommonStyles';

const empty = { totalEarnings: 0, sessionCount: 0, inProgressSessionCount: 0, hourlyEarnings: [] };

export default function OverviewTodayViewStaff({ data }) {
  const { t } = useTranslation('overview');

  const dailyData = data && typeof data === 'object'
    ? {
        totalEarnings: data.totalEarnings ?? 0,
        sessionCount: data.sessionCount ?? 0,
        inProgressSessionCount: data.inProgressSessionCount ?? 0,
        hourlyEarnings: data.hourlyEarnings ?? [],
      }
    : empty;

  return (
    <>
      <StatCardsRow>
        <StatCard
          icon={<MonetizationOnIcon fontSize="large" />}
          label={t('stats.totalEarnings')}
          value={`${dailyData.totalEarnings} €`}
          color="primary"
        />
        <StatCard
          icon={<PeopleIcon fontSize="large" />}
          label={t('stats.totalSessions')}
          value={dailyData.sessionCount}
          color="success"
        />
        <StatCard
          icon={<ListIcon fontSize="large" />}
          label={t('stats.inProgress')}
          value={dailyData.inProgressSessionCount}
          color="warning"
        />
      </StatCardsRow>
      <Paper elevation={0} sx={statPaper}>
        <Typography variant="subtitle1" sx={statTitle}>
          {t('charts.earningsByHour')}
        </Typography>
        <EarningsBarChartDaily hourlyEarnings={dailyData.hourlyEarnings} />
      </Paper>
    </>
  );
}